import { Box, Breadcrumbs, Link, Typography } from '@mui/material';

export const BreadcrumbBar: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'breadcrumb.main',
        px: { xs: 2, lg: 15 },
        py: 1.5,
        boxSizing: 'border-box',
      }}
    >
      <Breadcrumbs separator="/" aria-label="breadcrumb">
        <Link underline="always" color="primary.main" href="https://vabirthinjury.com/">
          Home
        </Link>
        <Typography color="primary.main">Payment Portal</Typography>
      </Breadcrumbs>
    </Box>
  );
};
